import axios from "axios";

export function saveConvention(convention: any) {
  return axios({
    method: "POST",
    url: "/api/Convention/saveConvention",
    headers: {
      "Content-Type": "application/json"
    },
    data: convention
  });
}

export function fetchSpecifiedConvention(conventionId: number) {
  return axios({
    method: "GET",
    url: `/api/Convention/convention/${conventionId}`
  });
}
